module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-single-6-79b25b6416fbec9c138fc77fed51c93f.jpg";